import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function AIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M23.5 1C27.6421 1 31 4.35786 31 8.5V23.5C31 27.6421 27.6421 31 23.5 31H8.5C4.35786 31 1 27.6421 1 23.5V8.5C1 4.35786 4.35786 1 8.5 1H23.5ZM14.4092 9.43359L9.4375 22.5625H13.2832L14.2168 19.752H18.5283L19.4717 22.5625H23.3174L18.3457 9.43359H14.4092ZM17.5947 16.9414H15.1592L16.377 13.0957L17.5947 16.9414Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
